// Build the URL for a collaboration and its sub-pages.
//
// Collaborations used to always live under a campaign/wave, hence the
// `/campaign/:campaignId/athlete/:collaborationId` route shape. They can now
// stand alone (e.g. auction/open-call wins) with no backing campaign, in which
// case they live under the campaign-free `/collaborations/:collaborationId`
// route. Passing a falsy `campaignId` yields the standalone path, which keeps
// `undefined` out of the URL (e.g. `/campaign/undefined/athlete/xyz`).

export const collabPath = (
  campaignId: string | null | undefined,
  collaborationId: string,
  suffix = '',
): string =>
  campaignId
    ? `/campaign/${campaignId}/athlete/${collaborationId}${suffix}`
    : `/collaborations/${collaborationId}${suffix}`

// Convenience for building the path from a collaboration object. A collaboration
// is standalone when explicitly flagged or when it has no campaign.
export const collabPathFor = (
  c: { id: string; campaignId?: string | null; standalone?: boolean },
  suffix = '',
): string => collabPath(c.standalone ? null : c.campaignId, c.id, suffix)
